module.exports = __webpack_public_path__ + "img/newlogo-fr.aa10f3c8.png";